import React from 'react';
import { Navbar, Nav, Container, Row, Col } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { scrollToTop, handleNavClick } from '../utils/scrollToTop';
import '../App.css';

function Layout({ children }) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  const handleLinkClick = (e, target) => {
    if (target && target.startsWith('#')) {
      handleNavClick(e, target);
    } else {
      scrollToTop();
    }
  };
  
  // Scroll to top when route changes
  React.useEffect(() => {
    const handleRouteChange = () => {
      scrollToTop();
    };
    
    // Scroll to top on initial load if no hash
    if (!window.location.hash || window.location.hash === '#') {
      scrollToTop();
    }
    
    return () => {};
  }, [location.pathname]);

  return (
    <div className="App">
      {/* Modern Navigation with Glassmorphism */}
      <Navbar expand="lg" fixed="top" className="modern-navbar">
        <Container>
          <Navbar.Brand as={Link} to="/" className="navbar-brand-modern" onClick={scrollToTop}>
            <img 
              src={`${process.env.PUBLIC_URL}/Logo1.jpeg`} 
              alt="DeepJyoti School Logo" 
              className="navbar-logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-toggler-modern" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {isHomePage ? (
                <>
                  <Nav.Link href="#home" className="nav-link-modern" onClick={(e) => handleLinkClick(e, '#home')}>Home</Nav.Link>
                  <Nav.Link href="#about" className="nav-link-modern" onClick={(e) => handleLinkClick(e, '#about')}>About</Nav.Link>
                  <Nav.Link href="#facilities" className="nav-link-modern" onClick={(e) => handleLinkClick(e, '#facilities')}>Facilities</Nav.Link>
                  <Nav.Link href="#programs" className="nav-link-modern" onClick={(e) => handleLinkClick(e, '#programs')}>Programs</Nav.Link>
                  <Nav.Link href="#contact" className="nav-link-modern" onClick={(e) => handleLinkClick(e, '#contact')}>Contact</Nav.Link>
                </>
              ) : (
                <Nav.Link as={Link} to="/" className="nav-link-modern" onClick={scrollToTop}>Home</Nav.Link>
              )}
              <Nav.Link as={Link} to="/privacy" className="nav-link-modern" onClick={scrollToTop}>Privacy Policy</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {children}

      {/* Enhanced Footer - Inspired by Kanakia Schools */}
      <footer className="footer-modern">
        <Container>
          <Row className="footer-main py-5">
            <Col md={4} className="mb-4 mb-md-0">
              <h5 className="footer-heading mb-3">DeepJyoti School</h5>
              <p className="footer-text mb-3">
                A Deepak Foundation Initiative<br />
                <a 
                  href="https://maps.app.goo.gl/cSkkRSbR8qRaqjST6" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link"
                  style={{ textDecoration: 'underline' }}
                >
                  Mira Road East, Thane, Maharashtra, India
                </a>
              </p>
              <p className="footer-text mb-3">
                (Mon to Fri | 9 AM to 4 PM)
              </p>
              <div className="social-links mt-3">
                <a href="https://www.instagram.com/deepjyotischool?igsh=MWxxNGNqMXlidWJtdA==" target="_blank" rel="noopener noreferrer" className="social-link me-3">
                  <i className="fab fa-instagram"></i> Instagram
                </a>
                <a href="https://www.facebook.com/share/1691ga4NEV/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <i className="fab fa-facebook"></i> Facebook
                </a>
              </div>
            </Col>
            <Col md={4} className="mb-4 mb-md-0">
              <h5 className="footer-heading mb-3">Quick Links</h5>
              <ul className="footer-links-list">
                <li><Link to="/" className="footer-link" onClick={scrollToTop}>Home</Link></li>
                <li><a href="#about" className="footer-link" onClick={(e) => handleLinkClick(e, '#about')}>About Us</a></li>
                <li><a href="#facilities" className="footer-link" onClick={(e) => handleLinkClick(e, '#facilities')}>Facilities</a></li>
                <li><a href="#programs" className="footer-link" onClick={(e) => handleLinkClick(e, '#programs')}>Programs</a></li>
                <li><a href="#contact" className="footer-link" onClick={(e) => handleLinkClick(e, '#contact')}>Contact</a></li>
              </ul>
            </Col>
            <Col md={4}>
              <h5 className="footer-heading mb-3">Contact & Legal</h5>
              <ul className="footer-links-list">
                <li><Link to="/privacy" className="footer-link" onClick={scrollToTop}>Privacy Policy</Link></li>
                <li><a href="#contact" className="footer-link" onClick={(e) => handleLinkClick(e, '#contact')}>Terms and Conditions</a></li>
              </ul>
              <div className="footer-contact mt-3">
                <p className="footer-text mb-1">
                  <strong>Phone:</strong> 7208282855 | 7045646649
                </p>
                <p className="footer-text mb-0">
                  <strong>Email:</strong> reachus@deepjyotischool.org
                </p>
              </div>
            </Col>
          </Row>
          <div className="footer-bottom text-center py-3 border-top border-light border-opacity-25">
            <p className="footer-text mb-2">&copy; 2025 DeepJyoti School. All rights reserved.</p>
            <p className="footer-tagline">A Deepak Foundation Initiative | Illuminating Minds, Shaping Futures</p>
          </div>
        </Container>
      </footer>
    </div>
  );
}

export default Layout;
